import { createAction } from "@reduxjs/toolkit";
import type { TeacherStudioListItem } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveTeacherStudio = createApiThunk<TeacherStudioListItem, string>(
  "teacher/studio/retrieve",
  async (id, { extra: { teacherRepository } }) => {
    return teacherRepository!.getStudioById(id);
  },
);

export const resetRetrieveTeacherStudio = createAction("teacher/studio/resetRetrieve");
